import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { ArticleCard } from "@/components/public/ArticleCard";
import { catLabel } from "@/lib/format";
import { useSeo } from "@/lib/seo";

export default function Category() {
  const { category } = useParams();
  const isLatest = !category || category === "latest";
  const slug = isLatest ? null : category;
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const url = slug ? `/articles?category=${slug}&limit=30` : `/articles?limit=30`;
    api.get(url).then((r) => setItems(r.data.articles || [])).catch(() => {}).finally(() => setLoading(false));
  }, [slug]);

  const title = isLatest ? "Latest" : catLabel(slug);
  useSeo({ title, description: `${title} — coverage and analysis from The Fin Desk on fintech, payments, banking and financial infrastructure.` });

  return (
    <div className="max-w-[1280px] mx-auto px-4 sm:px-6 py-10">
      <div className="border-b-2 border-ink pb-3 mb-8">
        <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-crimson">The Fin Desk</div>
        <h1 className="font-serif font-bold text-4xl sm:text-5xl text-ink mt-1">{title}</h1>
      </div>
      {loading ? <p className="text-mutedink">Loading…</p> : items.length === 0 ? (
        <p className="text-mutedink py-10">No published coverage in this section yet.</p>
      ) : (
        <>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-8"><ArticleCard a={items[0]} variant="lead" /></div>
            <div className="lg:col-span-4 lg:border-l lg:border-hair lg:pl-8">
              {items.slice(1, 6).map((a) => <ArticleCard key={a.id} a={a} variant="secondary" />)}
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-14">
            {items.slice(6).map((a) => <ArticleCard key={a.id} a={a} variant="standard" />)}
          </div>
        </>
      )}
    </div>
  );
}
